var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusOnTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_646_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.25C9.92282 1.25 11.7673 2.01341 13.127 3.37305C14.4866 4.73269 15.25 6.57718 15.25 8.5C15.25 10.4228 14.4866 12.2673 13.127 13.627C11.7673 14.9866 9.92282 15.75 8 15.75C6.07718 15.75 4.23269 14.9866 2.87305 13.627C1.51341 12.2673 0.75 10.4228 0.75 8.5C0.75 6.57718 1.51341 4.73269 2.87305 3.37305C4.23269 2.01341 6.07718 1.25 8 1.25Z",
    stroke: "#7E7ADF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.795 5.0127L6.87194 11.1665L4.4104 9.32039",
    stroke: "#7E7ADF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_646_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusOnTrack);
export default __webpack_public_path__ + "static/media/status-on-track.bf90d02d552b290b8927edac65cc5227.svg";
export { ForwardRef as ReactComponent };